/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.94"
        height="95.58"
        viewBox="0 0 79.94 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M46.71 0a14.86 14.86 0 0 1 14.86 14.55v10a1.27 1.27 0 0 1-1.19 1.32 1.25 1.25 0 0 1-1.31-1.19v-9.82a12.37 12.37 0 0 0-24.73-.3v10a1.27 1.27 0 0 1-1.19 1.32 1.25 1.25 0 0 1-1.31-1.19v-9.83A14.86 14.86 0 0 1 46.7 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M69.7 24.64H1.25A1.25 1.25 0 0 0 0 25.89v68.4a1.25 1.25 0 0 0 1.25 1.25H69.7a1.22 1.22 0 0 0 .46-.09l9-3.6a1.25 1.25 0 0 0 .78-1.16V29.5a1.25 1.25 0 0 0-.78-1.16l-9-3.6a1.23 1.23 0 0 0-.46-.1Zm-.24 2.5 8 3.19v59.55l-8 3.2h-67V27.14Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M33.24 0A14.86 14.86 0 0 1 48.1 14.55v21.74a1.27 1.27 0 0 1-1.19 1.32 1.25 1.25 0 0 1-1.31-1.19V14.86a12.37 12.37 0 0 0-24.73-.3v21.73a1.25 1.25 0 0 1-1.28 1.22 1.23 1.23 0 0 1-1.21-1.09V14.86A14.86 14.86 0 0 1 33.24 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M69.7 25.02a1.25 1.25 0 0 1 1.24 1.13v67.89a1.27 1.27 0 0 1-1.19 1.32 1.25 1.25 0 0 1-1.31-1.19V26.29a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperShoppingBagEmptyIcon';

export default Icon;
